import React from 'react';
import Collapsible from './Collapsible';
import { cubanBikeMarketData } from '../data/cubanBikeMarketData';

const CubanBikeMarket = () => {
    // Function to render paragraphs with line breaks
    const renderContent = (content) => {
        const paragraphs = content.split('\n\n'); // Split into paragraphs
        return paragraphs.map((paragraph, index) => (
            <p key={index}>{paragraph}</p> // Wrap each paragraph in <p> tag
        ));
    };

    return (
        <div>
            <h2>Cuban Bike Market</h2>
            {cubanBikeMarketData.map((section, index) => (
                <Collapsible key={index} title={section.title}>
                    {renderContent(section.content)} {/* Render the content with paragraphs */}
                </Collapsible>
            ))}
        </div>
    );
};

export default CubanBikeMarket;
